/**
 * @generated SignedSource<<d83f1edb958719ba70c24a105c6a3f78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionsCount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionsCursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionsFilters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionsSort"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "participativeModuleSlug"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "themeSlug"
},
v6 = [
  {
    "kind": "Variable",
    "name": "participativeModuleSlug",
    "variableName": "participativeModuleSlug"
  },
  {
    "kind": "Variable",
    "name": "themeSlug",
    "variableName": "themeSlug"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconClass",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryColor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryContrastColor",
  "storageKey": null
},
v13 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "contributionsCursor"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "contributionsFilters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "contributionsCount"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "contributionsSort"
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reactionsCount",
  "storageKey": null
},
v15 = [
  (v8/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContributionsDatavizGraphThemeRouteQuery",
    "selections": [
      {
        "alias": "theme",
        "args": (v6/*: any*/),
        "concreteType": "Theme",
        "kind": "LinkedField",
        "name": "participativeModuleTheme",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContributionsDatavizGraphTheme_theme"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContributionsDatavizGraphThemeRouteQuery",
    "selections": [
      {
        "alias": "theme",
        "args": (v6/*: any*/),
        "concreteType": "Theme",
        "kind": "LinkedField",
        "name": "participativeModuleTheme",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ParticipativeModule",
            "kind": "LinkedField",
            "name": "participativeModule",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "visualization",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enableListViewOnFirstPage",
                        "storageKey": null
                      }
                    ],
                    "type": "ContributionsDataviz",
                    "abstractKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipativeModuleAuthorizations",
                "kind": "LinkedField",
                "name": "authorizations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bookmarksCreationAuthorized",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "themes",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v7/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v7/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "ContributionConnection",
            "kind": "LinkedField",
            "name": "contributions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContributionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Contribution",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isBookmarked",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isMine",
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Theme",
                        "kind": "LinkedField",
                        "name": "themes",
                        "plural": true,
                        "selections": (v15/*: any*/),
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__id",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "filters": [
              "filters",
              "sort"
            ],
            "handle": "connection",
            "key": "ContributionsDatavizGraphTheme_contributions",
            "kind": "LinkedHandle",
            "name": "contributions"
          },
          (v16/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "parent",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "children",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v16/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "parent",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contributionsCount",
            "storageKey": null
          },
          (v14/*: any*/),
          (v8/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8fccb1850ce7079380be9fdc32342036",
    "id": null,
    "metadata": {},
    "name": "ContributionsDatavizGraphThemeRouteQuery",
    "operationKind": "query",
    "text": "query ContributionsDatavizGraphThemeRouteQuery(\n  $participativeModuleSlug: ID!\n  $themeSlug: ID!\n  $contributionsCount: Int!\n  $contributionsCursor: String\n  $contributionsFilters: ContributionsListFiltersInput\n  $contributionsSort: ContributionsSortInput\n) {\n  theme: participativeModuleTheme(participativeModuleSlug: $participativeModuleSlug, themeSlug: $themeSlug) {\n    ...ContributionsDatavizGraphTheme_theme\n    id\n  }\n}\n\nfragment BookmarkedFilter_participativeModule on ParticipativeModule {\n  authorizations {\n    bookmarksCreationAuthorized\n  }\n}\n\nfragment ContributionsDatavizContributionTooltip_theme on Theme {\n  name\n  iconClass\n  primaryColor\n  primaryContrastColor\n  parent {\n    name\n    id\n  }\n}\n\nfragment ContributionsDatavizFilters_participativeModule on ParticipativeModule {\n  ...ContributionsDatavizViewerFilters_participativeModule\n}\n\nfragment ContributionsDatavizGraphThemeAnimation_theme on Theme {\n  slug\n  primaryColor\n  primaryContrastColor\n  participativeModule {\n    id\n    slug\n  }\n  ...ContributionsDatavizContributionTooltip_theme\n}\n\nfragment ContributionsDatavizGraphTheme_theme on Theme {\n  participativeModule {\n    ...ContributionsDatavizMainContainerHeader_participativeModule\n    id\n    ...ContributionsDatavizViewModeSwitch_participativeModule\n  }\n  contributions(first: $contributionsCount, after: $contributionsCursor, filters: $contributionsFilters, sort: $contributionsSort) {\n    edges {\n      node {\n        id\n        slug\n        title\n        isBookmarked\n        isMine\n        reactionsCount\n        themes {\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...ContributionsDatavizThemeLayout_theme\n  ...ContributionsDatavizGraphThemeAnimation_theme\n  ...ContributionsDatavizMainContainerHeader_theme\n  id\n}\n\nfragment ContributionsDatavizMainContainerHeader_participativeModule on ParticipativeModule {\n  ...ContributionsDatavizViewModeSwitch_participativeModule\n}\n\nfragment ContributionsDatavizMainContainerHeader_theme on Theme {\n  ...ContributionsDatavizViewModeSwitch_theme\n}\n\nfragment ContributionsDatavizSearchFiltersThemes_themes on Theme {\n  id\n  name\n  primaryColor\n  primaryContrastColor\n  iconClass\n  parent {\n    id\n    parent {\n      id\n    }\n  }\n}\n\nfragment ContributionsDatavizTabs_participativeModule on ParticipativeModule {\n  slug\n  visualization {\n    __typename\n    ... on ContributionsDataviz {\n      enableListViewOnFirstPage\n    }\n    id\n  }\n}\n\nfragment ContributionsDatavizThemeLayout_theme on Theme {\n  participativeModule {\n    slug\n    ...ContributionsDatavizTabs_participativeModule\n    id\n  }\n  ...ContributionsDatavizThemeViewSidebar_theme\n  ...ContributionsDatavizViewModeSwitch_theme\n}\n\nfragment ContributionsDatavizThemeMeasures_theme on Theme {\n  contributionsCount\n  reactionsCount\n}\n\nfragment ContributionsDatavizThemeViewSidebar_theme on Theme {\n  name\n  iconClass\n  primaryColor\n  primaryContrastColor\n  parent {\n    name\n    id\n  }\n  children {\n    ...ContributionsDatavizSearchFiltersThemes_themes\n    id\n  }\n  participativeModule {\n    slug\n    ...ContributionsDatavizFilters_participativeModule\n    id\n  }\n  ...ContributionsDatavizThemeMeasures_theme\n  ...ContributionsDatavizThemesCarousel_currentTheme\n}\n\nfragment ContributionsDatavizThemesCarousel_currentTheme on Theme {\n  id\n  participativeModule {\n    slug\n    themes {\n      id\n      slug\n      iconClass\n      primaryColor\n      primaryContrastColor\n      children {\n        id\n        slug\n        iconClass\n        primaryColor\n        primaryContrastColor\n      }\n    }\n    id\n  }\n}\n\nfragment ContributionsDatavizViewModeSwitch_participativeModule on ParticipativeModule {\n  slug\n}\n\nfragment ContributionsDatavizViewModeSwitch_theme on Theme {\n  slug\n}\n\nfragment ContributionsDatavizViewerFilters_participativeModule on ParticipativeModule {\n  ...BookmarkedFilter_participativeModule\n}\n"
  }
};
})();

node.hash = "47667c21e5f08f2b3608dffcbb185c13";

module.exports = node;
